export default {"src":"/a/r/be1.10/_next/static/media/pin-red.8bf667f6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};